// src/utils/permission.js
import store from '@/store'

/**
 * 判断是否有权限
 * @param {string} code 权限代码
 * @returns {boolean}
 */
export function hasPerm(code) {
    if (!code) return false
    const permCodes = store.getters.permCodes || []
    const userId = store.getters.userId
    // 超级管理员（userId === 1）拥有所有权限
    return permCodes.includes(code) || userId === 1
}

/**
 * 判断是否有任意一个权限（或关系）
 * @param {Array} codes 权限代码数组
 * @returns {boolean}
 */
export function hasAnyPerm(codes) {
    if (!codes || !codes.length) return false
    return codes.some(code => hasPerm(code))
}

/**
 * 判断是否有全部权限（与关系）
 * @param {Array} codes 权限代码数组
 * @returns {boolean}
 */
export function hasAllPerms(codes) {
    if (!codes || !codes.length) return false
    return codes.every(code => hasPerm(code))
}